import pick from "lodash/pick";
import { Site } from "../types/Site";
import { fetchGet, fetchPost } from "./client";

export const getSite = async (siteId: Site["id"]) => {
  if (!siteId) return;

  try {
    const { result } = fetchGet(`/site/${siteId}`, {});
    const responseJson = await (await result).json();
    responseJson.id = responseJson._id;
    return responseJson as Site;
  } catch (e) {
    return;
  }
};

export const addSite = (site: Pick<Site, "geometry" | "title">) => {
  site.title = site.title || "Untitled";
  return fetchPost("/site", pick(site, "geometry", "title")).result;
};
